export default __webpack_public_path__ + "static/media/invoiceTimelineActive.38f1f411.svg";